<template>
  <div>
    <v-row class="ma-3" width="100%" min-height="100%" color="white" elevation="0">
      <v-col>
        <v-card>
          <v-card-title>
            <v-chip
              class="pointer"
              color="gray"
              label
              outlined
            >
              Non Sélectionné ({{ items.length }})
            </v-chip>
          </v-card-title>
          <v-card-text>
            <v-data-table
              v-model="itemsNoAffected"
              :headers="headers"
              :hide-default-footer="true"
              :items="items"
              :items-per-page="-1"
              show-select
              checkbox-color="third"
              item-key="uuid"
              :height="tableHeight"
              @click:row="rowClick"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="1" align="center" class="align-content-center">
        <v-icon size="48" color="third" @click="selectItems('deselect')"> mdi-chevron-left </v-icon>
        <v-icon size="48" color="third" @click="selectItems('select')"> mdi-chevron-right </v-icon>
      </v-col>
      <v-col>
        <v-card>
          <v-card-title>
            <v-chip
              class="pointer"
              color="gray"
              label
              outlined
            >
              Sélectionné ({{ itemsSelected.length }})
            </v-chip>
          </v-card-title>
          <v-card-text>
            <v-data-table
              v-model="itemsAffected"
              :headers="headers"
              show-select
              :hide-default-footer="true"
              :items="itemsSelected"
              :items-per-page="-1"
              :height="tableHeight"
              checkbox-color="third"
              item-key="uuid"
              @click:row="rowClick"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ref, computed, inject } from '@vue/composition-api';

import store from '@/store';

export default {
  props: {
    headers: {
      type: Array,
      default: null
    },
    items: {
      type: Array,
      default: null
    },
    itemsSelected: {
      type: Array,
      default: null
    }
  },
  setup (props, context) {
    const panel = ref([0, 1]);
    const itemsAffected = ref([]);
    const itemsNoAffected = ref([]);
    const tableHeight = inject('tableHeight');

    const rowClick = (item, row, event) => {
      event.stopPropagation();
      row.select(!row.isSelected);
    };

    const selectItems = actionType => {
      if (!store.getters.canUserPerformAction) {
        return;
      }
      context.emit('updateSelected', { selected: itemsAffected.value, deselected: itemsNoAffected.value, action: actionType });
      itemsNoAffected.value = [];
      itemsAffected.value = [];
    };

    const canUserPerformAction = computed(() => store.getters.canUserPerformAction);

    return { selectItems, panel, rowClick, itemsAffected, itemsNoAffected, canUserPerformAction, tableHeight };
  }
};

</script>
